/**
 * Full out-of-stock only when `size` has keys and every value is ≤ 0.
 * Empty map = no per-size inventory → not treated as fully OOS.
 */
export function isFullyOutOfStockFromSizeMap(productSizes) {
  const map =
    productSizes && typeof productSizes === 'object' && !Array.isArray(productSizes)
      ? productSizes
      : null;
  if (!map || Object.keys(map).length === 0) return false;
  return !Object.keys(map).some((k) => Number(map[k]) > 0);
}

/** Sum of numeric stock across all size keys (0 if map invalid). */
export function totalStockFromSizeMap(productSizes) {
  const map =
    productSizes && typeof productSizes === 'object' && !Array.isArray(productSizes)
      ? productSizes
      : {};
  return Object.keys(map).reduce((sum, k) => sum + Math.max(0, Number(map[k]) || 0), 0);
}
